import { KeycloakProfile } from 'keycloak-js';

export enum GroupsEnum {
  HRDIRECTOR = '/hh/hh. согласование вакансии (hr director)',
  REGIONAL_DIRECTOR = '/hh/hh. согласование вакансии (regional director)',
  ADMIN = '/hh/hh. администрирование',
  ADMIN_ALL_STORES = '/hh/hh. список магазинов для ао',
  CUSTOMER_DIRECTOR = '/hh/hh. согласование инициации заявки (customer director)',
  BACKUP_LEADER = '/hh/hh. исполняющий обязанности руководителя (backup leader)',
  CUSTOMER = '/hh/hh. инициация заявки (customer)',
  CUSTOMER_DC = '/hh/hh. инициация заявки рц (customer dc)',
  RECRUTER_DIRECTOR_DC = '/hh/hh. начальник отдела подбора рц (recruter director dc)',
  CLIENT = '/hh/hh. общее',
  RETAIL_JOBS_VIEWER = '/hh/hh. просмотр всех вакансий розницы',
  RECRUTER = '/hh/hh. работа с заявкой (recruter)',
  RECRUTER_DC = '/hh/hh. работа с заявкой рц (recruter dc)',
  RECRUTER_DIRECTOR = '/hh/hh. начальник отдела подбора (recruter director)',
  PARSING_REQUEST = '/hh/hh. парсинг вакансий hh',
  EXTERNAL_LINK = '/hh/hh. внешняя ссылка',
}

export interface JWTTokenParsed {
  groups: string[];
  email: string;
  num?: string;
  firstname?: string;
  secondname?: string;
  iat: number;
  exp: number;
}
export interface CustomKCProfile extends KeycloakProfile {
  attributes?: {
    num: string[];
    phoneNumber: string[];
    worklist: string[];
  };
}
